module.exports = __webpack_public_path__ + "img/arrow-r.3340a1d9.svg";